import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import dignitariesHero from "../assets/img/dignitaries/dignitaries-banner.png";
import governorImage from "../assets/img/leadership/Hon’ble Shri Raman Deka.png";
import chiefMinisterImage from "../assets/img/dignitaries/Shri Vishnu Dev Sai.png";
import regulatorImage from "../assets/img/dignitaries/Dr. Umesh Kumar Mishra.png";

const dignitaries = [
  {
    number: "01",
    name: "Hon’ble Shri Raman Deka",
    designation: "Hon’ble Governor of Chhattisgarh",
    image: governorImage,
    message: 'I am extremely pleased to learn that the Faculty of Arts and Humanities, ISBM University, Gariyaband, in collaboration with the Indian Council of World Affairs, is organizing a National Conference on the theme "Reimagining India\'s Neighbourhood Relations in a Changing Global Order." India\'s foreign policy places special emphasis on maintaining friendly, cooperative and mutually trusting relations with neighbouring countries. In the changing global scenario, India\'s role in promoting regional peace, stability, economic cooperation and shared development is becoming increasingly significant. I hope that this National Conference will provide a meaningful platform for new ideas and constructive dialogue and will bring forth valuable suggestions for further strengthening India\'s relations with its neighbouring countries. My best wishes for the success of the Conference.'
  },
  {
    number: "02",
    name: "Shri Vishnu Dev Sai",
    designation: "Hon'ble Chief Minister of Chhattisgarh",
    image: chiefMinisterImage,
    message: "Hon'ble Shri Vishnu Deo Sai Ji is an Indian politician currently serving as the Chief Minister of Chhattisgarh. He is the first senior tribal leader in Central India. Shri Vishnu Deo Sai Ji is the member of Bharatiya Janata Party (BJP) and Rashtriya Swayamsevak Sangh (RSS). He currently represents Kunkuri in Chhattisgarh Legislative Assembly. Shri Vishnu Deo Sai Ji is known for his decisive approach in addressing public welfare issues. His dedication extends beyond Chhattisgarh, as he has actively engaged with tribal concerns in states including Madhya Pradesh, Odisha, Telangana, and Maharashtra. Beyond politics, Shri Vishnu Deo Sai Ji has actively engaged in social work, particularly focused on tribal education and the development of essential infrastructure in tribal regions. He has been a consistent advocate for improving the living standards of backward tribes, reflecting a deep-rooted commitment to social welfare."
  },
  {
    number: "03",
    name: "Dr. Umesh Kumar Mishra",
    designation: "Chhattisgarh Niji Vishwavidyalaya Niyamak Aayog",
    image: regulatorImage,
    message: "Chhattisgarh Private Regulatory Commission, a statutory body of the Govt. of Chhattisgarh. It is responsible for providing guidance and supervision to the private Universities Established in the State of Chhattisgarh. The commission is dedicated to monitoring and supervising the academic standard of private Universities. The commission functions under the general control of the Visitor i.e. the Hon'ble Governor of Chhattisgarh. It consists of Chairman, Member Academic, and Member Administration. The Secretary looks after the functional aspect of the commission. The commission provides a regulatory mechanism in order to ensure appropriate standards in teaching, examination, research, protecting the interest of the student, and providing reasonable service conditions to the employees working in private Universities."
  }
];

export default function DignitariesMessages() {
  return (
    <>
      <MetaInfo param="" id="about" />
      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">
        <section className="relative isolate min-h-[70vh] overflow-hidden bg-[#071A2F] text-white">
          <img src={dignitariesHero} alt="ISBM University dignitaries" className="absolute inset-0 -z-30 h-full w-full object-cover" />
          <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(7,26,47,0.97)_0%,rgba(7,26,47,0.88)_42%,rgba(7,26,47,0.48)_72%,rgba(7,26,47,0.22)_100%)]" />
          <div className="absolute inset-0 -z-10 bg-[linear-gradient(0deg,rgba(7,26,47,0.85)_0%,transparent_52%)]" />

          <div className="mx-auto flex min-h-[70vh] w-[min(1380px,calc(100%-48px))] items-end pb-24 pt-[190px] max-sm:w-[calc(100%-28px)]">
            <div className="max-w-[940px]">
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Messages from Dignitaries
              </div>

              <h1 className="mt-7 max-w-[940px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.7vw,98px)] font-normal leading-[0.95] tracking-[-0.045em]">
                Words that reflect
                <span className="block text-[#D5AD57]">vision and leadership.</span>
              </h1>

              <p className="mt-8 max-w-[760px] text-[17px] leading-8 text-white/70">At our university, we are privileged to receive guidance and support from distinguished leaders who shape the educational landscape of Chhattisgarh. Their messages reflect our shared commitment to academic excellence, innovation, and social responsibility.</p>
            </div>
          </div>
        </section>

        <section className="bg-white py-20 sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="grid gap-14 lg:grid-cols-[420px_1fr] lg:gap-20">
              <figure className="relative min-h-[560px] overflow-hidden bg-[#E9E5DC]">
                <img src={dignitaries[0].image} alt={dignitaries[0].name} className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute inset-x-0 bottom-0 bg-[#071A2F]/88 p-7 text-white backdrop-blur-sm">
                  <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#D5AD57]">{dignitaries[0].number}</span>
                  <h2 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[31px] font-normal leading-[1.1]">{dignitaries[0].name}</h2>
                  <p className="mt-3 text-xs font-bold uppercase leading-6 tracking-[0.13em] text-[#D5AD57]">{dignitaries[0].designation}</p>
                </div>
              </figure>

              <div className="flex items-center">
                <div className="max-w-[800px]">
                  <Eyebrow>Message 01</Eyebrow>
                  <Title before="A Message of" highlight="Regional Vision" after="And Cooperation" position="middle" theme="burgundy" />
                  <div className="mt-10 border-l-[3px] border-[#D5AD57] pl-7 sm:pl-10">
                    <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(25px,2.5vw,36px)] font-normal leading-[1.48] text-[#071A2F]">{dignitaries[0].message}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24 lg:py-28">
          <div className="absolute -right-20 top-10 h-[420px] w-[420px] rounded-full border border-white/[0.06]" />
          <div className="relative mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="grid gap-14 lg:grid-cols-[1fr_420px] lg:items-center lg:gap-20">
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">{dignitaries[1].number}</span>
                <h2 className="mt-6 max-w-[760px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(42px,4.8vw,66px)] font-normal leading-[1.04] tracking-[-0.03em]">Leadership rooted in<span className="block text-[#D5AD57]">public welfare.</span></h2>
                <div className="mt-9 border-y border-white/15 py-9">
                  <p className="max-w-[820px] text-[17px] leading-9 text-white/72">{dignitaries[1].message}</p>
                </div>
              </div>

              <figure className="relative min-h-[580px] overflow-hidden bg-[#6A1530]">
                <img src={dignitaries[1].image} alt={dignitaries[1].name} className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute left-6 top-6 bg-[#F7F2E8] px-4 py-3 text-[#071A2F]">
                  <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[28px]">{dignitaries[1].number}</span>
                </div>
              </figure>
            </div>
          </div>
        </section>

        <section className="bg-[#EEF4F8] py-20 sm:py-24 lg:py-28">
          <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
            <div className="grid overflow-hidden border border-[#071A2F]/10 bg-white lg:grid-cols-[360px_1fr]">
              <div className="relative min-h-[500px] overflow-hidden bg-[#071A2F]">
                <img src={dignitaries[2].image} alt={dignitaries[2].name} className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/90 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                  <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#D5AD57]">{dignitaries[2].number}</span>
                  <h2 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[31px] font-normal leading-[1.1]">{dignitaries[2].name}</h2>
                  <p className="mt-3 text-xs font-bold uppercase leading-6 tracking-[0.13em] text-[#D5AD57]">{dignitaries[2].designation}</p>
                </div>
              </div>

              <div className="relative p-8 sm:p-10 lg:p-14">
                <div className="relative">
                  <Eyebrow>Message 03</Eyebrow>
                  <Title before="Standards That" highlight="Strengthen" after="Higher Education" position="middle" theme="burgundy" />
                  <p className="mt-8 max-w-[820px] text-[18px] leading-9 text-[#4F5D70]">{dignitaries[2].message}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#071A2F] py-20 text-white sm:py-24">
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-10 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.7fr_1.3fr] lg:gap-20">
            <div>
              <Eyebrow dark>Inspired by Leadership</Eyebrow>
              <Title before="Inspired by" highlight="Leadership" after="" position="middle" theme="gold" />
            </div>

            <div className="border-t border-white/15 pt-8">
              <p className="max-w-[800px] text-[17px] leading-9 text-white/65">These messages from our esteemed dignitaries serve as beacons that guide our institution's journey toward academic excellence and social impact. We are committed to upholding the values and vision shared by these leaders as we shape the future of education in Chhattisgarh.</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
